export const flashNotices = {
  incompleteProgram: {
    type: 'warning',
    message:
      'This program is not complete and only the owner of the program can complete it.',
  },
  programDeleted: {
    type: 'success',
    message: 'Program successfully deleted!',
  },
}
